<script setup>
import { useSettingsStore } from "@/stores/storeSettings";
import { sendMetrik } from '@/utils/metrika';
const storeSettings = useSettingsStore();
</script>
<template>
	<section class="restaurant" id="restaurant" v-if="storeSettings.settings?.banner_activity">
		<div class="container">
			<div class="restaurant__container">
				<div class="restaurant__content">
					<img class="restaurant__img" width="370" height="85" src="@/assets/img/restaurant/restaurant_logo.webp" alt="изображение" />
					<h2 class="restaurant__title">Специальное меню от ресторана «Поле»</h2>
					<p class="restaurant__desc">Шедевры искусства на тарелке — вдохновлённые Третьяковской галереей блюда, созданные вместе с «Мистраль»</p>
					<a @click="sendMetrik('reachGoal', 'Rest')" :href="storeSettings.settings?.banner_url" target="_blank" rel="noopener noreferrer" class="restaurant__btn btn --blue --small">
						Смотреть меню
						<svg width="32" height="32"><use href="#pdf"></use></svg>
					</a>
				</div>
			</div>
		</div>
	</section>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.restaurant {
	padding-top: 4.5rem;
	@media (max-width: vars.$x480) {
		padding-top: 1.5rem;
	}
}
.restaurant__container {
	border: 1px solid var(--border-inverse-3);
	border-radius: 3.2rem;
	padding: 5.1rem 2.4rem;
	display: grid;
	place-content: center;

	background-image: url('@/assets/img/restaurant/restaurant_bg_1.webp'), url('@/assets/img/restaurant/restaurant_bg_2.webp'),  url('@/assets/img/restaurant/restaurant_bg_3.webp');
	background-repeat: no-repeat;
	background-position: 0% 15%, 9% 100%, 100% 107%;
	background-size: 18.2rem,  9rem, 15.8rem;
	@media (max-width: vars.$t) {
		background-position: 0% 15%, 1% 100%, 100% 107%;
	}
	@media (max-width: vars.$x480) {
		background-image: url('@/assets/img/restaurant/restaurant_bg_1.webp'),  url('@/assets/img/restaurant/restaurant_bg_3.webp');
		background-repeat: no-repeat;
		background-position: 0% 12%, 100% 94%;
		background-size: 9.5rem, 6.3rem;
		padding: 5.1rem 2.4rem 4.3rem;
	}
}
.restaurant__content {
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: 1.7rem;
	@media (max-width: vars.$x480) {
		gap: 13px;
	}
}
.restaurant__img {
	width: 37rem;
	@media (max-width: vars.$x480) {
		width: 24.3rem;
	}
}
.restaurant__title {
	font-weight: 700;
	font-size: 4rem;
	line-height: 140%;
	text-transform: uppercase;
	text-align: center;
	color: var(--text-default-100);
	@media (max-width: vars.$x480) {
		font-size: 2.4rem;
	}
}
.restaurant__desc {
	font-weight: 400;
	font-size: 2rem;
	line-height: 160%;
	text-align: center;
	max-width: 66rem;
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
line-height: 140%;
	}
}
.restaurant__btn {
	gap: 8px;
	padding-top: 1.6rem;
	padding-bottom: 1.6rem;
	@media (max-width: vars.$x480) {
		width: 100%;
		font-size: 2.4rem;
	}
	svg {
		width: 3.2rem;
		height: 3.2rem;
	}
}
</style>
